import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { EnvironmentToken } from '../../util';
import { Environment } from '../../typings';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear: number;
  showApplicationSupport = true;
  privacyPolicyUrl: string;
  private subscriptions = new Subscription();

  constructor(
    @Inject(EnvironmentToken) private environment: Environment,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.updateForLanguage(this.translate.currentLang);
    this.subscriptions.add(
      this.translate.onLangChange.subscribe(event => this.updateForLanguage(event.lang))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private updateForLanguage(lang: string): void {
    const isFrench = (lang || '').toLowerCase().startsWith('fr');
    this.showApplicationSupport = !isFrench;
    this.privacyPolicyUrl = isFrench
      ? 'https://aquent.fr/privacy-policy/'
      : this.environment.aquentWebsite + '/privacy-policy';
  }

  navigateToUrl(event: any) {
    if (event.target.id === 'application-support') {
      top.location.replace(this.environment.aquentWebsite + '/eos');
    } else if (event.target.id === 'privacy-policy') {
      top.location.replace(this.privacyPolicyUrl);
    }
  }
}
